import { useCallback, useRef } from "react";
import {
  DEFAULT_PAGE_HEIGHT_PX,
  PAGE_MARGIN_PX,
} from "../model/pageTypes";

export function usePageHeights(pageModel) {
  const listRef = useRef(null);
  const heightsRef = useRef({});

  const getItemSize = useCallback(
    (index) => {
      const stored = heightsRef.current[index];
      if (stored) return stored;
      const page = pageModel[index];
      if (page?.type === "action-plan") {
        return DEFAULT_PAGE_HEIGHT_PX + PAGE_MARGIN_PX + 80;
      }
      return DEFAULT_PAGE_HEIGHT_PX + PAGE_MARGIN_PX;
    },
    [pageModel],
  );

  const setItemHeight = useCallback((index, height) => {
    const padded = height + PAGE_MARGIN_PX;
    if (heightsRef.current[index] === padded) return;
    heightsRef.current[index] = padded;
    listRef.current?.resetAfterIndex(index);
  }, []);

  return { listRef, getItemSize, setItemHeight };
}
